import { de as de$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var de = {
  language: 'de',
  country: 'de',
  name: 'Deutsch',
  embeddedLocale: merge(error, login),
  flags: ['DE'],
  dateFns: de$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { de as default };
